import React from "react";
import { FaCashRegister, FaDatabase, FaLaptopCode, FaCloud } from "react-icons/fa";
import "./SoftwareSolutions.css";

const SOFTWARES = [
  {
    title: "POS Software",
    desc: "Smart Point-of-Sale solutions for retail, restaurants, and inventory management.",
    icon: <FaCashRegister className="software-icon pos" />,
  },
  {
    title: "ERP Solutions",
    desc: "Enterprise Resource Planning software for seamless business operations.",
    icon: <FaDatabase className="software-icon erp" />,
  },
  {
    title: "CRM Tools",
    desc: "Customer relationship management systems to grow and maintain your client base.",
    icon: <FaCloud className="software-icon crm" />,
  },
  {
    title: "Custom Web & App Software",
    desc: "Tailored software solutions, web apps, and mobile apps for your unique needs.",
    icon: <FaLaptopCode className="software-icon custom" />,
  },
];

export default function SoftwareSolutions() {
  return (
    <section className="software" id="software">
      <div className="software__inner">
        <h2 className="software__title">Software Solutions</h2>
        <p className="software__subtitle">
          From POS to CRM, we build scalable software that transforms businesses.
        </p>

        <div className="software__grid">
          {SOFTWARES.map((s, idx) => (
            <article className="software-card" key={idx}>
              {s.icon}
              <h3>{s.title}</h3>
              <p>{s.desc}</p>
            </article>
          ))}
        </div>
      </div>
    </section>
  );
}
